import { ButtonProps, chakra, Icon } from '@chakra-ui/react';
import { ariaAttr } from '@chakra-ui/utils';
import { FC } from 'react';

import IconArrow from '@/assets/icons/ic-arrow-down.svg';

const StyledButton = chakra('button', {
  baseStyle: {
    zIndex: '5',
    display: 'inline-flex',
    alignItems: 'center',
    justifyItems: 'center',
    outline: 'none',
    border: 'none',
    color: 'white',
    background: 'black',
    padding: '5px',
    borderRadius: '50px',
    position: 'absolute',
    cursor: 'pointer',
    opacity: 1,
    transition: 'opacity 0.2s ease-out',
    _disabled: { opacity: 0 },
  },
});

export interface IScrollToBottomButtonProps extends ButtonProps {
  disabled: boolean;
  onClick: () => void;
}

export const ScrollToBottomButton: FC<IScrollToBottomButtonProps> = ({ onClick, disabled, ...rest }) => (
  <StyledButton
    aria-disabled={ariaAttr(disabled)}
    onClick={onClick}
    pointerEvents={disabled ? 'none' : 'unset'}
    {...rest}
  >
    <Icon as={IconArrow} w="24px" h="24px" />
  </StyledButton>
);
